import { breakpoints, Ratings, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

interface IHeaderProps {
  baseline?: boolean;
}

export const Header = styled.div<IHeaderProps>`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  padding: 0 2rem;

  button {
    margin: 0.5rem 0 1rem;
    display: block;
  }
`;

export const OverallValue = styled.span`
  ${theme.typography.titleLarge}
  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.titleDisplay}
  }
`;

export const StyledRatings = styled(Ratings)`
  display: inline-block !important;

  line-height: initial !important;

  svg {
    vertical-align: initial !important;
  }
`;

export const CollectReviewsLink = styled.a`
  display: block;
  font-size: 0.75rem;
  line-height: 1rem;
  color: ${theme.color.text.secondary};
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }

  margin-bottom: 1.5rem;
  @media (min-width: ${breakpoints.md}) {
    margin: 1rem 0 0;
    text-align: center;
  }
`;

export const InfoIconButton = styled.span``;

export const RatingInfoDrawerContent = styled.div`
  padding: 1.25rem;
  ${theme.typography.bodyRegular}
  color: ${theme.color.text.secondary};
`;
